"use strict";

module.exports = function () {
      return Object.keys(this.opts.templates);
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/computed/templates-keys.js